export default __webpack_public_path__ + "static/media/ziyuan.4281e505.png";